var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_44437",
    "data-name": "Group 44437",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1855,
    height: 203,
    viewBox: "0 0 1855 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42065",
    "data-name": "Group 42065",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M27.537,156a3.959,3.959,0,0,1-3.96-3.96v-3.96h-3.96a3.96,3.96,0,1,1,0-7.921h3.96V136.2a3.96,3.96,0,1,1,7.921,0v3.96h3.96a3.96,3.96,0,1,1,0,7.921H31.5v3.96A3.959,3.959,0,0,1,27.537,156Z",
    transform: "translate(1733.475 -132.239)",
    fill: "#ffe3c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26729",
    "data-name": "Path 26729",
    d: "M27.537,156a3.959,3.959,0,0,1-3.96-3.96v-3.96h-3.96a3.96,3.96,0,1,1,0-7.921h3.96V136.2a3.96,3.96,0,1,1,7.921,0v3.96h3.96a3.96,3.96,0,1,1,0,7.921H31.5v3.96A3.959,3.959,0,0,1,27.537,156Z",
    transform: "translate(1098.79 -116.545)",
    fill: "#9192ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42059",
    "data-name": "Group 42059",
    transform: "translate(491.862 163.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42061",
    "data-name": "Group 42061",
    transform: "translate(0 151.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-2",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44439",
    "data-name": "Group 44439",
    transform: "translate(1475.012 179.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-3",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#d9d9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42063",
    "data-name": "Group 42063",
    transform: "translate(794.41 59.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-4",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42066",
    "data-name": "Group 42066",
    transform: "translate(1114.447 163.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-5",
    "data-name": "Path 2356",
    d: "M167.418,16.12A11.881,11.881,0,1,1,155.537,4.239,11.9,11.9,0,0,1,167.418,16.12Zm-15.841,0a3.96,3.96,0,1,0,3.96-3.96A3.964,3.964,0,0,0,151.577,16.12Z",
    transform: "translate(-143.656 -4.239)",
    fill: "#ffe3c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42053",
    "data-name": "Group 42053",
    transform: "translate(964.06 118.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M320.57,125.969a2.379,2.379,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.391A2.379,2.379,0,0,0,320.57,125.969Zm2.015-7.779-2.015,2.015-2.015-2.015,2.015-2.015Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#d1d1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42060",
    "data-name": "Group 42060",
    transform: "translate(392.719 12.018)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42062",
    "data-name": "Group 42062",
    transform: "translate(61.204 15.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-2",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42067",
    "data-name": "Group 42067",
    transform: "translate(1839.443 187.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-3",
    "data-name": "Path 2376",
    d: "M50.193,333.205a2.388,2.388,0,0,0,1.688-.7l5.391-5.391a2.386,2.386,0,0,0,0-3.376l-5.391-5.391a2.387,2.387,0,0,0-3.376,0l-5.391,5.391a2.387,2.387,0,0,0,0,3.376l5.391,5.392A2.387,2.387,0,0,0,50.193,333.205Zm2.016-7.779-2.015,2.016-2.015-2.016,2.015-2.015Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestHeader);
export default __webpack_public_path__ + "static/media/testHeader.135565c79adf7e29875c50da86873242.svg";
export { ForwardRef as ReactComponent };